module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANYAAAAOCAYAAABTjuJsAAAAc0lEQVRoge3ZwQmEMBCG0bjYmFVtDVuVlylLiC0s4h+CvnfOKcMHIbP03hvzWL/7pYEcv20xxnl83n4BkCAsCBAWBAgLAoQFAcKCgLWq/LePEf0Or6p/j5r3APZYk7HHegZPQQgQFgQICwKEBQHCgru11k7N0hSuSWStuQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_bt.png
// module id = dufY
// module chunks = 0